<template>
  <v-tooltip bottom>
    <template slot="activator">
      <v-menu
        transition="slide-x-transition"
        bottom
        right
      >
        <v-btn
          slot="activator"
          small
          icon
          class="mx-1"
        >
          <v-icon>
            bookmarks
          </v-icon>
        </v-btn>
        <v-list>
          <v-list-tile
            v-for="item in items"
            :key="item.id"
            :disabled="disabled ? true : item.id === selectedVersion"
            @click="changeVersion(item.id)"
          >
            <v-list-tile-title>{{ item.title }}</v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-menu>
    </template>
    <span>Версия</span>
  </v-tooltip>
</template>

<script>
export default {
  props: ["items", "value", "disabled"],
  data() {
    return {
      selectedVersion: 0,
    };
  },
  methods: {
    changeVersion(version) {
      this.selectedVersion = version;
      this.$emit("input", version);
    },
  },
};
</script>
